const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const {
  GET_CARTS,
  GET_CARTS_COUNT,
  CREATE_CART,
  DELETE_CART,
  CREATE_SERVICES_CART,
  REORDER,
  GET_SERVICES_CARTS,
} = require("./constants");

const {
  cartSuccess,
  cartError,

  cartsCountSuccess,
  cartsCountError,

  createCartSuccess,
  createCartError,

  deleteCartSuccess,
  deleteCartError,

  servicesCartSuccess,
  servicesCartError,

  createServicesCartSuccess,
  createServicesCartError,

  reOrderSuccess,
  reOrderError,
} = require("./actions");

const cart = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_CARTS),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .cart(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
        })
        .then((response) => cartSuccess(response.data))
        .catch((error) => cartError(error))
    )
  );

const ServicesCart = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_SERVICES_CARTS),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .ServiceCart(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          is_business: action.payload.isBusiness,
          mode: action.payload.mode,
        })
        .then((response) => servicesCartSuccess(response.data))
        .catch((error) => servicesCartError(error))
    )
  );

const countCarts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_CARTS_COUNT),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .cartsCount(marketplace)
        .then((response) => cartsCountSuccess(response.data))
        .catch((error) => cartsCountError(error))
    )
  );

const reOrder = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(REORDER),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .createCart(marketplace, {
          inventory_id: action.payload.inventoryId,
          quantity: action.payload.quantity,
          coupon_id: action.payload.couponId,
          is_business: action.payload.isBusiness,
          operation: action.payload.operation,
        })
        .then((response) => reOrderSuccess(response.data))
        .catch((error) => reOrderError(error))
    )
  );

const createCart = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CREATE_CART),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .createCart(marketplace, {
          inventory_id: action.payload.inventoryId,
          quantity: action.payload.quantity,
          coupon_id: action.payload.couponId,
          is_business: action.payload.isBusiness,
          operation: action.payload.operation,
        })
        .then((response) => createCartSuccess(response.data))
        .catch((error) => createCartError(error))
    )
  );

const createServicesCart = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CREATE_SERVICES_CART),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .createServicesCart(marketplace, action.payload.mode, {
          package_id: action.payload.packageId,
          quantity: action.payload.quantity,
          coupon_id: action.payload.couponId,
          is_business: action.payload.isBusiness,
          operation: action.payload.operation,
        })
        .then((response) => createServicesCartSuccess(response.data))
        .catch((error) => createServicesCartError(error))
    )
  );
const deleteCarts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(DELETE_CART),
    mergeMap((action) =>
      marketplaceApi.marketCart
        .delCart(marketplace, action.payload.id)
        .then((response) => deleteCartSuccess(response.data))
        .catch((error) => deleteCartError(error))
    )
  );

module.exports = {
  cart,
  countCarts,
  createCart,
  deleteCarts,
  createServicesCart,
  reOrder,
  ServicesCart,
};
